const LIST_STATE_KEY = 'paron-admin-list-state'

// Filters used to live in one shared slot, which leaked them between sections
;['paron-admin-filters', 'paron-admin-sortOption', 'paron-admin-sortOrder'].forEach(key => localStorage.removeItem(key))

function readListStates() {
    try {
        return JSON.parse(localStorage.getItem(LIST_STATE_KEY)) || {}
    } catch (e) {
        return {}
    }
}

export default {
    state: {
        currentUser: {
            role: localStorage.getItem('role'),
            dealerId: localStorage.getItem('dealer-id') ? localStorage.getItem('dealer-id') : null
        },
        token: localStorage.getItem('api-token'),
        listStates: readListStates()
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setCurrentUser(state, value) {
            state.currentUser = value
        },
        setListState(state, { key, value }) {
            state.listStates = { ...state.listStates, [key]: value }
        },
        clearListStates(state) {
            state.listStates = {}
        }
    },
    actions: {
        setListState({ commit, state }, { key, value }) {
            commit('setListState', { key, value })
            localStorage.setItem(LIST_STATE_KEY, JSON.stringify(state.listStates))
        },
        logout({ dispatch, commit }) {
            dispatch('setCurrentUser', null)
            dispatch('setToken', null)
            commit('clearListStates')
            localStorage.removeItem(LIST_STATE_KEY)
        },
        login({ dispatch }, resp) {
            if (resp.data.token) {
                dispatch('setToken', resp.data.token)
                dispatch('setCurrentUser', {
                    role: resp.data.role,
                    dealerId: resp.data.dealer
                })
            }
        },
        setToken({ commit }, token) {
            if (token) {
                localStorage.setItem('api-token', token)
                commit('setToken', token)
            } else {
                localStorage.removeItem('api-token')
                commit('setToken', null)
            }
        },
        setCurrentUser({ commit }, currentUser) {
            if (currentUser) {
                if (currentUser.dealerId && currentUser.dealerId !== 'null') {
                    localStorage.setItem('dealer-id', currentUser.dealerId)
                } else {
                    currentUser.dealerId = null
                    localStorage.removeItem('dealer-id')
                }
                localStorage.setItem('role', currentUser.role)
                commit('setCurrentUser', currentUser)
            } else {
                localStorage.removeItem('dealer-id')
                localStorage.removeItem('role')
                commit('setCurrentUser', null)
            }
        }
    },
    getters: {
        getListState: state => key => state.listStates[key] || { filters: {}, sortOption: null, order: 'ASC' },
        getToken: state => state.token === null || state.token === 'null' ? null : state.token,
        currentUser: (state) => {
            if (!state.currentUser || (!state.currentUser.role && !state.currentUser.dealerId)) {
                return null
            }
            return state.currentUser
        },
        isAdmin: (state, getters) => !!getters.currentUser && getters.currentUser.role === 'admin',
        isDealer: (state, getters) => !!getters.currentUser && getters.currentUser.role === 'dealer',
        dealerId: (state, getters) => getters.isDealer ? getters.currentUser.dealerId : null,
        isLoggedIn(state, getters) {
            return getters.getToken !== null
        }
    }
}
